import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FirstStepService } from './first-step.service';
import { Observable } from 'rxjs';
import { ServiceResource } from '../model/serviceResource';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { CreateCalculationRequest } from '../model/createCalculationRequest';
import { CalculationResource } from '../model/calculationResource';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-first-step',
  templateUrl: './first-step.component.html',
  styleUrls: ['./first-step.component.scss']
})
export class FirstStepComponent implements OnInit {

  @Output() calculation = new EventEmitter<CalculationResource>();
  @Output() change = new EventEmitter<Boolean>();

  services$!: Observable<Array<ServiceResource>>;
  calculationForm: FormGroup;
  services: number[] = [];

  constructor(
    public _service: FirstStepService,
    private _formBuilder: FormBuilder,
  ) {

    this.calculationForm = this._formBuilder.group({
      height: ['', [Validators.required]],
      width: ['', [Validators.required]],
      count: ['', [Validators.required]],
    });

  }

  ngOnInit(): void {

    const savedFormData = localStorage.getItem('calculationForm');
    const savedParams = localStorage.getItem('calculationParams');

    if (savedFormData) {
      const parsedData = JSON.parse(savedFormData);
      this.calculationForm.patchValue(parsedData);
    }

    if (savedParams) {
      const parsedData = JSON.parse(savedParams);
      this.services = parsedData;
    }

    this.services$ = this._service.fetchServices();

    this.calculationForm.valueChanges.subscribe((formData) => {
      this.saveToLocalStorage();
      this.change.emit(true);
    });

  }

  onSubmit(): void{
    const formValues = this.calculationForm.getRawValue();

    let output: CreateCalculationRequest = {
      height: formValues.height,
      width: formValues.width,
      count: formValues.count,
      serviceIds: this.services,
      realization: false,
      typeId: Number(environment.typeId)
    };

    this._service.createCalculation(output).subscribe( result => {
      this.calculation.emit(result);
    });
  }

  onCheckboxChange($event: any, serviceNumber: number): void{
    this.services = this.services.filter(item => item !== serviceNumber);
    if($event.target.checked){ this.services.push(serviceNumber); }
    localStorage.setItem('calculationParams', JSON.stringify(this.services));
    this.change.emit(true);
  }

  saveToLocalStorage(): void {
    const formData = this.calculationForm.value;
    localStorage.setItem('calculationForm', JSON.stringify(formData));
    localStorage.setItem('calculationParams', JSON.stringify(this.services));
  }

  checkParam(id: number): boolean {
    return this.services.includes(id);
  }

}
